export const SIGN_IN = "/identity/sign-in";
export const SIGN_UP = "/identity/sign-up";
export const CONFIRM_EMAIL = "/auth/confirm-email";
export const CURRENT_USER = "/identity/current-user";
export const REFRESH_TOKEN = "/identity/refresh-token";
export const COMPANY_PROFILE = "/company-profile";
//
export const GET_PRODUCTS = "/products";
//
export const GET_PRODUCTS_BY_CATEGORIES = "/products/category";
export const GET_CATEGORIES = "/categories";
export const GET_CATEGORIES_HIERACHY = "/categories/hierarchy";
export const BASKET_CHECKOUT = "/basket/checkout";
export const GET_ORDERS = "/orders/customer";
export const GET_ORDER_DETAILS = "/orders";
export const POST_INITIATE_PAYMENT = "/orders";
export const GET_LOCATIONS = "/locations/current";
export const SUBMIT_PRESCRIPTION = "/prescriptions/submit";
//
export const GET_BASKET = "/basket";
export const ADD_BASKET = "/basket/items";
export const REMOVE_ITEM_BASKET = "/basket/items";
//
export const GET_STORES = "/stores";
//
export const GET_BRANDS = "/brands";
//
export const GET_BANNERS = "/banners";
//
export const SEARCH_ANALYTICS = "/analytics/search/log";
export const TENANTS = "/tenants";
